import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "app-main-content": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_BiddingsList = _resolveComponent("BiddingsList")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!

  return (_openBlock(), _createBlock(_component_app_main_layout, null, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: "" }, {
        left: _withCtx(() => [
          _createVNode(_component_el_page_header, { "nav-title": "" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Bids ", -1)
            ]))]),
            _: 1
          })
        ]),
        center: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", null, null, -1)
        ]))]),
        right: _withCtx(() => [...(_cache[2] || (_cache[2] = []))]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_BiddingsList, { biddings: _ctx.biddings }, null, 8, ["biddings"])
      ])
    ]),
    _: 1
  }))
}